



















import { defineComponent, computed } from '@vue/composition-api';
import { useInjectAbTest } from '@tt4b/ttam-hooks';
import { checkURL } from '@tt4b/ttam-utils';
import InputTooltip from '@/components/common/input-tooltip/index.vue';

const name = 'ttam-creative-deeplink-fallback-input';
export default defineComponent({
  name,
  components: {
    InputTooltip,
  },
  props: {
    value: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const { isInputUrlIterationTooltipTest } = useInjectAbTest();
    const _externalUrl = computed({
      get: () => props.value,
      set: v => {
        emit('change', v);
        emit('input', v);
      },
    });

    return {
      name,
      _externalUrl,
      isInputUrlIterationTooltipTest,
      checkURL,
    };
  },
});
